import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'vpa-address-disclaimer',
  templateUrl: './address-disclaimer.component.html',
  styleUrls: ['./address-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressDisclaimerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
